import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';
import { mediaSchema } from './media-schema';

export const conversationMessageSchema = new schema.Entity(EntityTypes.ConversationMessage, {
  media: [mediaSchema],
});
